(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*global $, jQuery, alert, console*/

"use strict";

$(document).ready(function () {

    if(document.querySelector('.s-calculator') !== null) {
        calculatorInit();
    }

    function calculatorInit() {
        let common_options = {
            start: 1,
            connect: 'lower',
            snap: true,
            orientation: 'horizontal',
            tooltips: true,
            range: []

        };

        if(document.querySelectorAll('.sliderCustom').length > 0) {
            document.querySelectorAll('.sliderCustom').forEach(item => {
                let el = item;
                let el_name = item.dataset.sliderCustom;
                let options = common_options;

                if(el_name === 'number_of_apps'){
                    options.format = {
                        to: val => val,
                        from: val => val.replace(',', '')
                    }
                    options.range = {
                        'min': 1,
                        '3%': 2,
                        '6%': 5,
                        '10%': 10,
                        '13%': 20,
                        '16%': 30,
                        '20%': 40,
                        '23%': 50,
                        '26%': 60,
                        '30%': 70,
                        '33%': 80,
                        '36%': 90,
                        '40%': 100,
                        '43%': 110,
                        '46%': 120,
                        '50%': 130,
                        '53%': 140,
                        '56%': 150,
                        '60%': 160,
                        '63%': 170,
                        '66%': 180,
                        '70%': 190,
                        '73%': 200,
                        '76%': 300,
                        '80%': 400,
                        '83%': 500,
                        '86%': 600,
                        '90%': 700,
                        '93%': 800,
                        '96%': 900,
                        'max': 1000
                    };
                }

                if(el_name === 'average_cpu') {
                    options.range = {
                        'min': 1,
                        '25%': 2,
                        '50%': 4,
                        '75%': 8,
                        'max': 16
                    };
                    options.format = {
                        to: val => val + ' Core',
                        from: val => val.replace(',', '')
                    }
                }

                if(el_name === 'average_memory') {
                    options.range = {
                        'min': 64,
                        '20%': 128,
                        '40%': 256,
                        '60%': 512,
                        '80': 1024,
                        'max': 2048
                    };
                    options.format = {
                        to: val => val + '  MB',
                        from: val => val.replace(',', '')
                    }
                    options.start = 64;
                }

                if(el_name === 'cpu') {
                    options.range = {
                        'min': 8,
                        '33%': 16,
                        '66%': 24,
                        'max': 32
                    };
                    options.start = 8;
                    options.format = {
                        to: val => val + ' Core',
                        from: val => val.replace(',', '')
                    }
                }

                if(el_name === 'memory') {
                    options.range = {
                        'min': 32,
                        '33%': 64,
                        '66%': 96,
                        'max': 128
                    };
                    options.start = 32;
                    options.format = {
                        to: val => val + ' GB',
                        from: val => val.replace(',', '')
                    }
                }

                if(el_name === 'extra_capacity') {
                    options.range = {
                        'min': 10,
                        '20%': 20,
                        '30%': 30,
                        '40%': 40,
                        '50%': 50,
                        '60%': 60,
                        '70%': 70,
                        '80%': 80,
                        '90%': 90,
                        'max': 100
                    };
                    options.start = 10;
                    options.format = {
                        to: val => val + ' %',
                        from: val => val.replace(',', '')
                    }
                }

                el.dataset.sliderCurrentvalue = options.start;
                noUiSlider.create(el, options);
            });
        }

        let numberOfApps = '';
        let averageCpu = '';
        let averageMemory = '';
        let nodesCpu = '';
        let nodesMemory =    '';
        let clusterPercent = '';
        let provider = 'GKE';
        let calcCount = '';

        let finishPrice = '';

        getSelectData();
        countAllData();

        function updateSliderData(values, handle, unencoded, tap, positions) {
            let current_el = this.target.dataset.sliderCustom;
            let current_value = unencoded[0];

            this.target.dataset.sliderCurrentvalue = current_value;

            if(current_el === 'number_of_apps'){
                numberOfApps = current_value;
            }
            if(current_el === 'average_cpu'){
                averageCpu = current_value;
            }
            if(current_el === 'average_memory'){
                averageMemory = current_value;
            }
            if(current_el === 'cpu'){
                nodesCpu = current_value;
            }
            if(current_el === 'memory'){
                nodesMemory = current_value;
            }
            if(current_el === 'extra_capacity'){
                clusterPercent = current_value;
            }

            countAllData();
        }

        document.querySelectorAll('.sliderCustom').forEach(el => {
            el.noUiSlider.on('change', updateSliderData);
        });

        function getSelectData() {
            numberOfApps = +document.querySelector('.sliderCustom[data-slider-custom="number_of_apps"]').dataset.sliderCurrentvalue;
            averageCpu = +document.querySelector('.sliderCustom[data-slider-custom="average_cpu"]').dataset.sliderCurrentvalue;
            averageMemory = +document.querySelector('.sliderCustom[data-slider-custom="average_memory"]').dataset.sliderCurrentvalue;
            nodesCpu = +document.querySelector('.sliderCustom[data-slider-custom="cpu"]').dataset.sliderCurrentvalue;
            nodesMemory = +document.querySelector('.sliderCustom[data-slider-custom="memory"]').dataset.sliderCurrentvalue;
            clusterPercent = +document.querySelector('.sliderCustom[data-slider-custom="extra_capacity"]').dataset.sliderCurrentvalue;


            let totalCPU = numberOfApps * averageCpu;
            let totalMemory = numberOfApps * averageMemory;

            let num1 = totalCPU / nodesCpu;
            let num2 = totalMemory / nodesMemory;
            let usage = Math.max(num1, num2);

            let capacityScale = 1 + clusterPercent / 100;

            calcCount = Math.ceil(capacityScale * usage);
        }


        function GKECalc() {
            let price = (16.153221 * nodesCpu + 2.165107 * nodesMemory);

            finishPrice = Number((price * calcCount).toFixed(2));
        }

        function AKSCalc() {
            let dataAKS = [
                {cpu: 1, mem: 0.5, cost: 11.1252},
                {cpu: 1, mem: 1, cost: 15.6950},
                {cpu: 1, mem: 2, cost: 24.82},
                {cpu: 2, mem: 4, cost: 42.997},
                {cpu: 2, mem: 8, cost: 79.4240},
                {cpu: 4, mem: 16, cost: 152.57},
                {cpu: 8, mem: 32, cost: 297.84},
                {cpu: 12, mem: 48, cost: 443.84},
                {cpu: 16, mem: 64, cost: 589.84},
                {cpu: 20, mem: 80, cost: 735.1100}
            ];

            let fixPoint = 1000;

            let prices = dataAKS.filter(item => item.cpu === nodesCpu && item.mem === nodesMemory).map(item => item.cost * fixPoint);
            if (prices < 1) {
                return null;
            }

            let price = prices > 1 ? prices.reduce((cur, res) => res + cur / 2) : prices[0];

            finishPrice = Number((price / fixPoint * calcCount).toFixed(2));
        }

        function EKSCalc() {
            let dataEKS = [
                {cpu: 2, mem: 0.5, cost: 0.0062},
                {cpu: 2, mem: 1, cost: 0.0124},
                {cpu: 2, mem: 2, cost: 0.0248},
                {cpu: 2, mem: 4, cost: 0.0496},
                {cpu: 2, mem: 8, cost: 0.0992},
                {cpu: 4, mem: 16, cost: 0.1984},
                {cpu: 8, mem: 32, cost: 0.3968},
                {cpu: 2, mem: 0.5, cost: 0.0056},
                {cpu: 2, mem: 1, cost: 0.0112},
                {cpu: 2, mem: 2, cost: 0.0223},
                {cpu: 2, mem: 4, cost: 0.0446},
                {cpu: 2, mem: 8, cost: 0.0893},
                {cpu: 4, mem: 16, cost: 0.1786},
                {cpu: 8, mem: 32, cost: 0.3571},
                {cpu: 1, mem: 0.5, cost: 0.0069},
                {cpu: 1, mem: 1, cost: 0.0138},
                {cpu: 1, mem: 2, cost: 0.0276},
                {cpu: 2, mem: 4, cost: 0.0552},
                {cpu: 2, mem: 8, cost: 0.1104},
                {cpu: 4, mem: 16, cost: 0.2208},
                {cpu: 8, mem: 32, cost: 0.4416},
                {cpu: 2, mem: 8, cost: 0.112},
                {cpu: 4, mem: 16, cost: 0.224},
                {cpu: 8, mem: 32, cost: 0.448},
                {cpu: 16, mem: 64, cost: 0.896},
                {cpu: 32, mem: 128, cost: 1.792},
                {cpu: 48, mem: 192, cost: 2.688},
                {cpu: 64, mem: 256, cost: 3.584},
                {cpu: 96, mem: 384, cost: 5.376},
                {cpu: 96, mem: 384, cost: 5.376},
                {cpu: 2, mem: 8, cost: 0.101},
                {cpu: 4, mem: 16, cost: 0.202},
                {cpu: 8, mem: 32, cost: 0.404},
                {cpu: 16, mem: 64, cost: 0.808},
                {cpu: 32, mem: 128, cost: 1.616},
                {cpu: 48, mem: 192, cost: 2.424},
                {cpu: 64, mem: 256, cost: 3.232},
                {cpu: 96, mem: 384, cost: 4.848},
                {cpu: 2, mem: 8, cost: 0.133},
                {cpu: 4, mem: 16, cost: 0.266},
                {cpu: 8, mem: 32, cost: 0.532},
                {cpu: 16, mem: 64, cost: 1.064},
                {cpu: 32, mem: 128, cost: 2.128},
                {cpu: 48, mem: 192, cost: 3.192},
                {cpu: 64, mem: 256, cost: 4.256},
                {cpu: 96, mem: 384, cost: 6.384},
                {cpu: 96, mem: 384, cost: 6.384},
                {cpu: 2, mem: 8, cost: 0.117},
                {cpu: 4, mem: 16, cost: 0.234},
                {cpu: 8, mem: 32, cost: 0.468},
                {cpu: 16, mem: 64, cost: 0.936},
                {cpu: 40, mem: 160, cost: 2.34},
                {cpu: 64, mem: 256, cost: 3.744},
            ];

            let fixPoint = 1000;

            let prices = dataEKS.filter(item => item.cpu === nodesCpu && item.mem === nodesMemory).map(item => item.cost * fixPoint);
            if (prices < 1) {
                useAdvantage();
                return null;
            }

            let price = prices > 1 ? prices.reduce((cur, res) => res + cur / 2) : prices[0];

            finishPrice = Number(((price / fixPoint * calcCount + 0.2) * 730).toFixed(2));
        }

        function showResult() {
            $('.s-calculator__bottom-node span').text(calcCount);
            $('.s-calculator__bottom-cost span').text('$ ' + finishPrice);
        }

        function useAdvantage() {
            let advanced = document.querySelector('.s-calculator__block-advance');
            document.querySelector('.s-calculator__block-basic .btn__wrap').classList.add('disabled-btn');
            document.querySelector('.s-calculator__point-inform').classList.remove('hide');

            disabledBtn();

            $([document.documentElement, document.body]).animate({
                scrollTop: $(advanced).offset().top - 80
            }, 300);

            window.setTimeout(function () {
                advanced.querySelector('#first_name_p').focus();
            }, 0);
        }

        function removeUsageAdvance() {
            document.querySelector('.s-calculator__block-basic .btn__wrap').classList.remove('disabled-btn');
            document.querySelector('.s-calculator__point-inform').classList.add('hide');

            disabledBtn();
        }

        function countAllData() {
            removeUsageAdvance();
            getSelectData();

            if (provider == 'GKE') {
                GKECalc();
            } else if (provider == 'AKS') {
                AKSCalc();
            } else if (provider == 'EKS') {
                EKSCalc();
            } else if (provider == 'on-prem') {
                useAdvantage()
            }

            showResult();
        }

        document.querySelector('.calc__select').addEventListener('change', function (e) {
            provider = e.target.value;

            countAllData();
        });

        function disabledBtn() {
            let basic_btn = document.querySelector('.s-calculator__block-basic .btn__wrap');

            if(basic_btn !== null) {
                if(basic_btn.classList.contains('disabled-btn')) {
                    basic_btn.addEventListener('click', preventEvent)
                } else {
                    basic_btn.removeEventListener('click', preventEvent)
                }
            }
        }

        function preventEvent(e) {
            e.preventDefault();
        }
    }
});
},{}]},{},[1])